export function fixtureArticles(fixture) {
    if (!("articles" in fixture) || !Array.isArray(fixture.articles)) {
        return [];
    }
    return fixture.articles;
}
export function resolveArticleDestination(articles, destination) {
    if (destination.type !== "article") {
        return { status: "not-article" };
    }
    const article = articles.find((candidate) => candidate.id === destination.id);
    return article
        ? { article, status: "available" }
        : { articleId: destination.id, status: "unavailable" };
}
export function shouldDismissArticleReader(downwardDragDistance) {
    return downwardDragDistance >= 72;
}
